import { render, staticRenderFns } from "./TopCurrency.vue?vue&type=template&id=4d49ad6a&scoped=true&"
import script from "./TopCurrency.vue?vue&type=script&lang=js&"
export * from "./TopCurrency.vue?vue&type=script&lang=js&"
import style0 from "./TopCurrency.vue?vue&type=style&index=0&id=4d49ad6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d49ad6a",
  null
  
)

export default component.exports